import classNames from "classnames";
import { FC } from "react";
import styles from "./Hamburger.module.css";

interface Props {
  isOpen: boolean;
  isDisabled?: boolean;
  className?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Hamburger: FC<Props> = ({ isOpen, isDisabled = false, className, onClick }: Props) => (
  <button
    className={classNames(className, styles.hamburger, {
      [styles.open]: isOpen,
    })}
    onClick={onClick}
    disabled={isDisabled}
  >
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </button>
);

export default Hamburger;
